import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/Comments/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/LikeButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/NewsFeed/Controller.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/NewsFeed/FeedShimmer.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/workspace/components/NewsFeed/InfiniteFeed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CardBody"] */ "/home/app/workspace/components/VideoCard/CardBody/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/VideoCard/DeleteButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/VideoCard/ReadMore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/VideoCard/ShareBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeedProvider"] */ "/home/app/workspace/contexts/feedContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/app/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/app/workspace/node_modules/next/dist/client/image-component.js");
